module.exports = __webpack_public_path__ + "img/insta7.5824d516.jpg";